// Third Party
import * as React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  IconDefinition,
  faArrowRight,
  faArrowRightArrowLeft,
  faAward,
  faSquareDollar,
  faBriefcase,
  faBars,
  faBell,
  faBed,
  faWindow,
  faCalendar,
  faCalendarRange,
  faCheck,
  faCircleX,
  faChevronLeft,
  faChevronRight,
  faChevronDown,
  faChevronUp,
  faCircleCheck,
  faCircleExclamation,
  faCreditCard,
  faComment,
  faEllipsisVertical,
  faEnvelope,
  faEye,
  faEyeSlash,
  faSliders,
  faGiftCard,
  faGlobe,
  faUserGroup,
  faHandshake,
  faHeart,
  faHouseChimney,
  faImage,
  faInfoCircle,
  faLink,
  faLocationDot,
  faLock,
  faMailbox,
  faMagnifyingGlass,
  faMap,
  faMinus,
  faMobile,
  faMobileNotch,
  faPhone,
  faPaperclip,
  faPaperPlane,
  faPenToSquare,
  faQuestionCircle,
  faSackDollar,
  faScaleBalanced,
  faShieldHeart,
  faSpinner,
  faShower,
  faToilet,
  faTrash,
  faTrashCan,
  faTriangleExclamation,
  faUser,
  faUserPlus,
  faUserCircle,
  faUpload,
  faShareFromSquare,
  faWeightHanging,
  faX,
  faPumpMedical,
  faPeopleGroup,
  faPlateUtensils,
  faFamily,
  faWifi,
  faFireplace,
  faWheelchair,
  faPencil,
  faTag,
  faToiletPaper,
  faBedFront,
  faBanSmoking,
  faCircleParking,
  faPaw,
  faTv,
  faStar,
  faPlus,
  faCode,
  faArrowUpRightFromSquare,
  faArrowUp,
  faTruckFast,
  faCopy,
  faBellConcierge,
} from '@fortawesome/pro-regular-svg-icons';
import {
  faPlus as sfaPlus,
  faArrowRight as sfaArrowRight,
  faArrowRightArrowLeft as sfaArrowRightArrowLeft,
  faArrowUp as sfaArrowUp,
  faArrowUpRightFromSquare as sfaArrowUpRightFromSquare,
  faBars as sfaBars,
  faAward as sfaAward,
  faSquareDollar as sfaSquareDollar,
  faBell as sfaBell,
  faBed as sfaBed,
  faBriefcase as sfaBriefcase,
  faWindow as sfaWindow,
  faCalendar as sfaCalendar,
  faCalendarRange as sfaCalendarRange,
  faCircleX as sfaCircleX,
  faCheck as sfaCheck,
  faChevronLeft as sfaChevronLeft,
  faChevronRight as sfaChevronRight,
  faChevronDown as sfaChevronDown,
  faChevronUp as sfaChevronUp,
  faCircleCheck as sfaCircleCheck,
  faCircleExclamation as sfaCircleExclamation,
  faComment as sfaComment,
  faCreditCard as sfaCreditCard,
  faEnvelope as sfaEnvelope,
  faEye as sfaEye,
  faEyeSlash as sfaEyeSlash,
  faHandshake as sfaHandshake,
  faHeart as sfaHeart,
  faHouseChimney as sfaHouseChimney,
  faImage as sfaImage,
  faInfoCircle as sfaInfoCircle,
  faEllipsisVertical as sfaEllipsisVertical,
  faSliders as sfaSliders,
  faLink as sfaLink,
  faLock as sfaLock,
  faLocationDot as sfaLocationDot,
  faMap as sfaMap,
  faMailbox as sfaMailbox,
  faMagnifyingGlass as sfaMagnifyingGlass,
  faMinus as sfaMinus,
  faMobile as sfaMobile,
  faMobileNotch as sfaMobileNotch,
  faPaperPlane as sfaPaperPlane,
  faPaperclip as sfaPaperclip,
  faPenToSquare as sfaPenToSquare,
  faPhone as sfaPhone,
  faShieldHeart as sfaShieldHeart,
  faQuestionCircle as sfaQuestionCircle,
  faSackDollar as sfaSackDollar,
  faSpinner as sfaSpinner,
  faScaleBalanced as sfaScaleBalanced,
  faShower as sfaShower,
  faToilet as sfaToilet,
  faTruckFast as sfaTruckFast,
  faTriangleExclamation as sfaTriangleExclamation,
  faTrash as sfaTrash,
  faTrashCan as sfaTrashCan,
  faUserGroup as sfaUserGroup,
  faUpload as sfaUpload,
  faUser as sfaUser,
  faUserPlus as sfaUserPlus,
  faPencil as sfaPencil,
  faShareFromSquare as sfaShareFromSquare,
  faUserCircle as sfaUserCircle,
  faWeightHanging as sfaWeightHanging,
  faX as sfaX,
  faPumpMedical as sfaPumpMedical,
  faPeopleGroup as sfaPeopleGroup,
  faPlateUtensils as sfaPlateUtensils,
  faFamily as sfaFamily,
  faWifi as sfaWifi,
  faFireplace as sfaFireplace,
  faWheelchair as sfaWheelchair,
  faTag as sfaTag,
  faToiletPaper as sfaToiletPaper,
  faBedFront as sfaBedFront,
  faBanSmoking as sfaBanSmoking,
  faCircleParking as sfaCircleParking,
  faPaw as sfaPaw,
  faTv as sfaTv,
  faStar as sfaStar,
  faCode as sfaCode,
  faBellConcierge as sfaBellConcierge,
} from '@fortawesome/pro-solid-svg-icons';
import {
  faGiftCard as sfaGiftCard,
  faGlobe as sfaGlobe,
} from '@fortawesome/sharp-thin-svg-icons';
import {
  faYoutube,
  faFacebook,
  faPinterest,
  faTwitter,
  faXTwitter,
  faInstagram,
  faLinkedin,
  faApple,
  faGoogle,
  faSalesforce,
  faStripe,
  faLinkedinIn,
  faTiktok,
} from '@fortawesome/free-brands-svg-icons';
import {
  faCcAmex,
  faCcVisa,
  faCcMastercard,
  faCcDiscover,
} from '@fortawesome/free-brands-svg-icons';

export type IconSizes =
  | 'xs'
  | 'lg'
  | 'sm'
  | '1x'
  | '2x'
  | '3x'
  | '4x'
  | '5x'
  | '6x'
  | '7x'
  | '8x'
  | '9x'
  | '10x';

export enum IconNames {
  APPLE = 'APPLE',
  ASSOCIATIONS = 'ASSOCIATIONS',
  AWARD = 'AWARD',
  ARROW_RIGHT = 'ARROW_RIGHT',
  ARROW_RIGHTLEFT = 'ARROW_RIGHTLEFT',
  ARROWUPRIGHTFROMSQUARE = 'ARROWUPRIGHTFROMSQUARE',
  ARROW_UP = 'ARROW_UP',
  SQUARE_DOLLAR = 'SQUARE_DOLLAR',
  BARS = 'BARS',
  BELL = 'BELL',
  BED = 'BED',
  BROWSER = 'BROWSER',
  CALENDAR = 'CALENDAR',
  CALENDAR_RANGE = 'CALENDAR_RANGE',
  CHECK = 'CHECK',
  CHAT = 'CHAT',
  COPY = 'COPY',
  CHEVRON_LEFT = 'CHEVRON_LEFT',
  CHEVRON_RIGHT = 'CHEVRON_RIGHT',
  CHEVRON_UP = 'CHEVRON_UP',
  CHEVRON_DOWN = 'CHEVRON_DOWN',
  CIRCLE_CHECK = 'CIRCLE_CHECK',
  CIRCLE_EXCLAMATION = 'CIRCLE_EXCLAMATION',
  CIRCLE_X = 'CIRCLE_X',
  CREDIT_CARD = 'CREDIT_CARD',
  COMMENT = 'COMMENT',
  ELLIPSIS_VERTICAL = 'ELLIPSIS_VERTICAL',
  ENVELOPE = 'ENVELOPE',
  EYE = 'EYE',
  EYE_SLASH = 'EYE_SLASH',
  FACEBOOK = 'FACEBOOK',
  FILTER = 'FILTER',
  HANDSHAKE = 'HANDSHAKE',
  HEART = 'HEART',
  HOUSE_CHIMNEY = 'HOUSE_CHIMNEY',
  IMAGE = 'IMAGE',
  INSPECTIONS = 'INSPECTIONS',
  GOOGLE = 'GOOGLE',
  GIFT_CARD = 'GIFT_CARD',
  GLOBE = 'GLOBE',
  INFO_CIRCLE = 'INFO_CIRCLE',
  INSTAGRAM = 'INSTAGRAM',
  LOCK = 'LOCK',
  LINK = 'LINK',
  LOCATION_DOT = 'LOCATION_DOT',
  MAP = 'MAP',
  MAILBOX = 'MAILBOX',
  MINUS = 'MINUS',
  MAGNIFYING_GLASS = 'MAGNIFYING_GLASS',
  MOBILE = 'MOBILE',
  MOBILE_NOTCH = 'MOBILE_NOTCH',
  PEN_TO_SQUARE = 'PEN_TO_SQUARE',
  PHONE = 'PHONE',
  PAPER_PLANE = 'PAPER_PLANE',
  PAPERCLIP = 'PAPERCLIP',
  PINTEREST = 'PINTEREST',
  QUESTION_CIRCLE = 'QUESTION_CIRCLE',
  SACK_DOLLAR = 'SACK_DOLLAR',
  SCALE_BALANCED = 'SCALE_BALANCED',
  SPINNER = 'SPINNER',
  SHOWER = 'SHOWER',
  TAG = 'TAG',
  TIKTOK = 'TIKTOK',
  TOILET = 'TOILET',
  TWITTER = 'TWITTER',
  TWITTERX = 'TWITTERX',
  TRASH = 'TRASH',
  TRASH_CAN = 'TRASH_CAN',
  TRUCK_FAST = 'TRUCK_FAST',
  USER = 'USER',
  USER_GROUP = 'USER_GROUP',
  USER_CIRCLE = 'USER_CIRCLE',
  USER_PLUS = 'USER_PLUS',
  UPLOAD = 'UPLOAD',
  WEIGHT_HANGING = 'WEIGHT_HANGING',
  TRIANGLE_EXCLAMATION = 'TRIANGLE_EXCLAMATION',
  X = 'X',
  SHARE = 'SHARE',
  YOUTUBE = 'YOUTUBE',
  PUMP_MEDICAL = 'PUMP_MEDICAL',
  PEOPLE_GROUP = 'PEOPLE_GROUP',
  PLATE_UTENSILS = 'PLATE_UTENSILS',
  FAMILY = 'FAMILY',
  WIFI = 'WIFI',
  FIREPLACE = 'FIREPLACE',
  WHEELCHAIR = 'WHEELCHAIR',
  TOILET_PAPER = 'TOILET_PAPER',
  BED_FRONT = 'BED_FRONT',
  BAN_SMOKING = 'BAN_SMOKING',
  CIRCLE_PARKING = 'CIRCLE_PARKING',
  PAW = 'PAW',
  PENCIL = 'PENCIL',
  TV = 'TV',
  STAR = 'STAR',
  PLUS = 'PLUS',
  CODE = 'CODE',
  SALESFORCE = 'SALESFORCE',
  STRIPE = 'STRIPE',
  BELL_CONCIERGE = 'BELL_CONCIERGE',
  LINKEDIN = 'LINKEDIN',
  CC_AMEX = 'CC_AMEX',
  CC_VISA = 'CC_VISA',
  CC_MASTERCARD = 'CC_MASTERCARD',
  CC_DISCOVER = 'CC_DISCOVER',
}

export interface IconProps {
  solid?: boolean;
  className?: string;
  name: IconNames;
  size?: IconSizes;
  title?: string;
}

export const Icon: React.FC<IconProps> = ({
  size,
  name,
  className = '',
  solid = false,
  title = '',
}) => {
  return (
    <FontAwesomeIcon
      data-id={`ICON-${name}`}
      icon={solid ? iconNameToSolidFA(name) : iconNameToFA(name)}
      className={'icon ' + className}
      size={size}
      title={title}
    />
  );
};

const iconNameToFA = (name: IconNames): IconDefinition => {
  switch (name) {
    case IconNames.APPLE:
      return faApple;
    case IconNames.GOOGLE:
      return faGoogle;
    case IconNames.FILTER:
      return faSliders;
    case IconNames.PLUS:
      return faPlus;
    case IconNames.ASSOCIATIONS:
      return faShieldHeart;
    case IconNames.AWARD:
      return faAward;
    case IconNames.ARROW_RIGHT:
      return faArrowRight;
    case IconNames.ARROW_RIGHTLEFT:
      return faArrowRightArrowLeft;
    case IconNames.ARROW_UP:
      return faArrowUp;
    case IconNames.ARROWUPRIGHTFROMSQUARE:
      return faArrowUpRightFromSquare;
    case IconNames.SQUARE_DOLLAR:
      return faSquareDollar;
    case IconNames.BED:
      return faBed;
    case IconNames.BELL:
      return faBell;
    case IconNames.BROWSER:
      return faWindow;
    case IconNames.CALENDAR:
      return faCalendar;
    case IconNames.CALENDAR_RANGE:
      return faCalendarRange;
    case IconNames.CHAT:
      return faComment;
    case IconNames.CHECK:
      return faCheck;
    case IconNames.CIRCLE_CHECK:
      return faCircleCheck;
    case IconNames.CIRCLE_EXCLAMATION:
      return faCircleExclamation;
    case IconNames.CIRCLE_X:
      return faCircleX;
    case IconNames.FACEBOOK:
      return faFacebook;
    case IconNames.BARS:
      return faBars;
    case IconNames.CHEVRON_LEFT:
      return faChevronLeft;
    case IconNames.CHEVRON_RIGHT:
      return faChevronRight;
    case IconNames.CHEVRON_UP:
      return faChevronUp;
    case IconNames.CHEVRON_DOWN:
      return faChevronDown;
    case IconNames.CREDIT_CARD:
      return faCreditCard;
    case IconNames.CC_AMEX:
      return faCcAmex;
    case IconNames.CC_VISA:
      return faCcVisa;
    case IconNames.CC_MASTERCARD:
      return faCcMastercard;
    case IconNames.CC_DISCOVER:
      return faCcDiscover;
    case IconNames.ENVELOPE:
      return faEnvelope;
    case IconNames.EYE:
      return faEye;
    case IconNames.EYE_SLASH:
      return faEyeSlash;
    case IconNames.HEART:
      return faHeart;
    case IconNames.HANDSHAKE:
      return faHandshake;
    case IconNames.HOUSE_CHIMNEY:
      return faHouseChimney;
    case IconNames.IMAGE:
      return faImage;
    case IconNames.INSPECTIONS:
      return faBriefcase;
    case IconNames.GIFT_CARD:
      return faGiftCard;
    case IconNames.GLOBE:
      return faGlobe;
    case IconNames.LOCK:
      return faLock;
    case IconNames.LINK:
      return faLink;
    case IconNames.ELLIPSIS_VERTICAL:
      return faEllipsisVertical;
    case IconNames.LOCATION_DOT:
      return faLocationDot;
    case IconNames.MAP:
      return faMap;
    case IconNames.MINUS:
      return faMinus;
    case IconNames.INFO_CIRCLE:
      return faInfoCircle;
    case IconNames.PAPER_PLANE:
      return faPaperPlane;
    case IconNames.PEN_TO_SQUARE:
      return faPenToSquare;
    case IconNames.PINTEREST:
      return faPinterest;
    case IconNames.PHONE:
      return faPhone;
    case IconNames.SPINNER:
      return faSpinner;
    case IconNames.MAILBOX:
      return faMailbox;
    case IconNames.MAGNIFYING_GLASS:
      return faMagnifyingGlass;
    case IconNames.MOBILE:
      return faMobile;
    case IconNames.MOBILE_NOTCH:
      return faMobileNotch;
    case IconNames.INSTAGRAM:
      return faInstagram;
    case IconNames.COMMENT:
      return faComment;
    case IconNames.WEIGHT_HANGING:
      return faWeightHanging;
    case IconNames.QUESTION_CIRCLE:
      return faQuestionCircle;
    case IconNames.SACK_DOLLAR:
      return faSackDollar;
    case IconNames.SHOWER:
      return faShower;
    case IconNames.TAG:
      return faTag;
    case IconNames.TIKTOK:
      return faTiktok;
    case IconNames.TOILET:
      return faToilet;
    case IconNames.TRUCK_FAST:
      return faTruckFast;
    case IconNames.TWITTER:
      return faTwitter;
    case IconNames.TWITTERX:
      return faXTwitter;
    case IconNames.SCALE_BALANCED:
      return faScaleBalanced;
    case IconNames.X:
      return faX;
    case IconNames.PAPERCLIP:
      return faPaperclip;
    case IconNames.PENCIL:
      return faPencil;
    case IconNames.USER_CIRCLE:
      return faUserCircle;
    case IconNames.TRASH:
      return faTrash;
    case IconNames.TRASH_CAN:
      return faTrashCan;
    case IconNames.TRIANGLE_EXCLAMATION:
      return faTriangleExclamation;
    case IconNames.YOUTUBE:
      return faYoutube;
    case IconNames.USER:
      return faUser;
    case IconNames.USER_GROUP:
      return faUserGroup;
    case IconNames.USER_PLUS:
      return faUserPlus;
    case IconNames.UPLOAD:
      return faUpload;
    case IconNames.SHARE:
      return faShareFromSquare;
    case IconNames.LINKEDIN:
      return faLinkedin;
    case IconNames.PUMP_MEDICAL:
      return faPumpMedical;
    case IconNames.PEOPLE_GROUP:
      return faPeopleGroup;
    case IconNames.PLATE_UTENSILS:
      return faPlateUtensils;
    case IconNames.FAMILY:
      return faFamily;
    case IconNames.WIFI:
      return faWifi;
    case IconNames.FIREPLACE:
      return faFireplace;
    case IconNames.WHEELCHAIR:
      return faWheelchair;
    case IconNames.TAG:
      return faTag;
    case IconNames.TOILET_PAPER:
      return faToiletPaper;
    case IconNames.BED_FRONT:
      return faBedFront;
    case IconNames.BAN_SMOKING:
      return faBanSmoking;
    case IconNames.CIRCLE_PARKING:
      return faCircleParking;
    case IconNames.PAW:
      return faPaw;
    case IconNames.TV:
      return faTv;
    case IconNames.STAR:
      return faStar;
    case IconNames.CODE:
      return faCode;
    case IconNames.SALESFORCE:
      return faSalesforce;
    case IconNames.STRIPE:
      return faStripe;
    case IconNames.COPY:
      return faCopy;
    case IconNames.BELL_CONCIERGE:
      return faBellConcierge;
    case IconNames.LINKEDIN:
      return faLinkedinIn;
    case IconNames.CC_AMEX:
      return faCcAmex;
    case IconNames.CC_VISA:
      return faCcVisa;
    case IconNames.CC_MASTERCARD:
      return faCcMastercard;
    case IconNames.CC_DISCOVER:
      return faCcDiscover;
  }
};

const iconNameToSolidFA = (name: IconNames): IconDefinition => {
  switch (name) {
    case IconNames.APPLE:
      return faApple;
    case IconNames.GOOGLE:
      return faGoogle;
    case IconNames.FILTER:
      return sfaSliders;
    case IconNames.PLUS:
      return sfaPlus;
    case IconNames.ASSOCIATIONS:
      return sfaShieldHeart;
    case IconNames.AWARD:
      return sfaAward;
    case IconNames.ARROW_RIGHT:
      return sfaArrowRight;
    case IconNames.ARROW_RIGHTLEFT:
      return sfaArrowRightArrowLeft;
    case IconNames.ARROW_UP:
      return sfaArrowUp;
    case IconNames.ARROWUPRIGHTFROMSQUARE:
      return sfaArrowUpRightFromSquare;
    case IconNames.SQUARE_DOLLAR:
      return sfaSquareDollar;
    case IconNames.BED:
      return sfaBed;
    case IconNames.BELL:
      return sfaBell;
    case IconNames.BROWSER:
      return sfaWindow;
    case IconNames.CALENDAR:
      return sfaCalendar;
    case IconNames.CALENDAR_RANGE:
      return sfaCalendarRange;
    case IconNames.CHAT:
      return sfaComment;
    case IconNames.CHECK:
      return sfaCheck;
    case IconNames.BARS:
      return sfaBars;
    case IconNames.CIRCLE_CHECK:
      return sfaCircleCheck;
    case IconNames.CIRCLE_EXCLAMATION:
      return sfaCircleExclamation;
    case IconNames.CIRCLE_X:
      return sfaCircleX;
    case IconNames.FACEBOOK:
      return faFacebook;
    case IconNames.GIFT_CARD:
      return sfaGiftCard;
    case IconNames.GLOBE:
      return sfaGlobe;
    case IconNames.CHEVRON_LEFT:
      return sfaChevronLeft;
    case IconNames.CHEVRON_RIGHT:
      return sfaChevronRight;
    case IconNames.CHEVRON_UP:
      return sfaChevronUp;
    case IconNames.CHEVRON_DOWN:
      return sfaChevronDown;
    case IconNames.CREDIT_CARD:
      return sfaCreditCard;
    case IconNames.ENVELOPE:
      return sfaEnvelope;
    case IconNames.EYE:
      return sfaEye;
    case IconNames.EYE_SLASH:
      return sfaEyeSlash;
    case IconNames.HEART:
      return sfaHeart;
    case IconNames.HANDSHAKE:
      return sfaHandshake;
    case IconNames.HOUSE_CHIMNEY:
      return sfaHouseChimney;
    case IconNames.IMAGE:
      return sfaImage;
    case IconNames.INSPECTIONS:
      return sfaBriefcase;
    case IconNames.LOCK:
      return sfaLock;
    case IconNames.LINK:
      return sfaLink;
    case IconNames.LOCATION_DOT:
      return sfaLocationDot;
    case IconNames.MINUS:
      return sfaMinus;
    case IconNames.INFO_CIRCLE:
      return sfaInfoCircle;
    case IconNames.PAPER_PLANE:
      return sfaPaperPlane;
    case IconNames.PEN_TO_SQUARE:
      return sfaPenToSquare;
    case IconNames.PINTEREST:
      return faPinterest;
    case IconNames.PENCIL:
      return sfaPencil;
    case IconNames.PHONE:
      return sfaPhone;
    case IconNames.ELLIPSIS_VERTICAL:
      return sfaEllipsisVertical;
    case IconNames.MAP:
      return sfaMap;
    case IconNames.MAILBOX:
      return sfaMailbox;
    case IconNames.MAGNIFYING_GLASS:
      return sfaMagnifyingGlass;
    case IconNames.MOBILE:
      return sfaMobile;
    case IconNames.MOBILE_NOTCH:
      return sfaMobileNotch;
    case IconNames.SPINNER:
      return sfaSpinner;
    case IconNames.COMMENT:
      return sfaComment;
    case IconNames.QUESTION_CIRCLE:
      return sfaQuestionCircle;
    case IconNames.SACK_DOLLAR:
      return sfaSackDollar;
    case IconNames.INSTAGRAM:
      return faInstagram;
    case IconNames.WEIGHT_HANGING:
      return sfaWeightHanging;
    case IconNames.TIKTOK:
      return faTiktok;
    case IconNames.TWITTER:
      return faTwitter;
    case IconNames.TWITTERX:
      return faXTwitter;
    case IconNames.TRASH:
      return sfaTrash;
    case IconNames.TRASH_CAN:
      return sfaTrashCan;
    case IconNames.SCALE_BALANCED:
      return sfaScaleBalanced;
    case IconNames.X:
      return sfaX;
    case IconNames.PAPERCLIP:
      return sfaPaperclip;
    case IconNames.USER_CIRCLE:
      return sfaUserCircle;
    case IconNames.TRIANGLE_EXCLAMATION:
      return sfaTriangleExclamation;
    case IconNames.TRUCK_FAST:
      return sfaTruckFast;
    case IconNames.SHOWER:
      return sfaShower;
    case IconNames.TOILET:
      return sfaToilet;
    case IconNames.YOUTUBE:
      return faYoutube;
    case IconNames.USER:
      return sfaUser;
    case IconNames.USER_GROUP:
      return sfaUserGroup;
    case IconNames.USER_PLUS:
      return sfaUserPlus;
    case IconNames.UPLOAD:
      return sfaUpload;
    case IconNames.SHARE:
      return sfaShareFromSquare;
    case IconNames.LINKEDIN:
      return faLinkedin;
    case IconNames.PUMP_MEDICAL:
      return sfaPumpMedical;
    case IconNames.PEOPLE_GROUP:
      return sfaPeopleGroup;
    case IconNames.PLATE_UTENSILS:
      return sfaPlateUtensils;
    case IconNames.FAMILY:
      return sfaFamily;
    case IconNames.WIFI:
      return sfaWifi;
    case IconNames.FIREPLACE:
      return sfaFireplace;
    case IconNames.WHEELCHAIR:
      return sfaWheelchair;
    case IconNames.TAG:
      return sfaTag;
    case IconNames.TOILET_PAPER:
      return sfaToiletPaper;
    case IconNames.BED_FRONT:
      return sfaBedFront;
    case IconNames.BAN_SMOKING:
      return sfaBanSmoking;
    case IconNames.CIRCLE_PARKING:
      return sfaCircleParking;
    case IconNames.PAW:
      return sfaPaw;
    case IconNames.TV:
      return sfaTv;
    case IconNames.STAR:
      return sfaStar;
    case IconNames.CODE:
      return sfaCode;
    case IconNames.SALESFORCE:
      return faSalesforce;
    case IconNames.STRIPE:
      return faStripe;
    case IconNames.COPY:
      return faCopy;
    case IconNames.BELL_CONCIERGE:
      return sfaBellConcierge;
    case IconNames.LINKEDIN:
      return faLinkedinIn;
    case IconNames.CC_AMEX:
      return faCcAmex;
    case IconNames.CC_VISA:
      return faCcVisa;
    case IconNames.CC_MASTERCARD:
      return faCcMastercard;
    case IconNames.CC_DISCOVER:
      return faCcDiscover;
  }
};
